import BtnSimple from "@/src-refactor/modules/shared/components/buttons/BtbSimple";
import FormModal from "@/src-refactor/modules/shared/components/modals/form-modal/FormModal";
import { Form, Formik, FormikConfig, FormikHelpers } from "formik";
import { FC, useEffect, useMemo } from "react";
import {
  ASSESSMENT_FORM_ENUMS,
  IAssessmentForm,
  assessmentInitialForm
} from "./util/form.util";
import styled from "@emotion/styled";
import RatingField from "@/src-refactor/modules/shared/components/rating/RatingField";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import TextAreaField from "@/src-refactor/modules/shared/components/fields/text-area-field/TextAreaField";
import { useSedFeedbackMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import { assessmentAdapter } from "./util/assessment-adapter";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { useRealEstateDetailContext } from "../../../pages/realestate-detail/context/realestate-details.context";
import { validationAssesmentSchema } from "./util/validationAssesmentSchema";
import MxTypography from "@rf-l1/MxTypography";
import MxFormL3TextAreaField from "@rf-l3/form/MxFormL3TextAreaField";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";
interface IAssessmentModalProps {
  useDetailContext?: boolean;
}

const AssessmentModal: FC<IAssessmentModalProps> = props => {
  return (
    <FormModal
      FormComponent={<AssessmentContent {...props} />}
      btnToggle={<BtnSimple variant-custom="mute" id="id-rating-modal" />}
      title="Valoración"
    />
  );
};

export default AssessmentModal;

interface IAssessmentContentProps {
  modalToggle?: () => void;
  useDetailContext?: boolean;
}

const AssessmentContent: FC<IAssessmentContentProps> = props => {
  const location = useLocation();
  const navigate = useNavigate();
  const ctx = props.useDetailContext ? useRealEstateDetailContext() : null;
  const isProject = useMemo(() => !!ctx?.PROPERTY_DETAIL.project.buildings, [ctx]);
  const { guardReadOnlyAction } = useReadOnlyModeGuard();

  const [SEND_FEEDBACK_M, SEND_FEEDBACK_DATA] = useSedFeedbackMutation();

  const handleValidation = (values: IAssessmentForm) => {
    if (!values.rating) {
      toast.error("Selecciona una calificación para enviar");
      return false;
    }
    return true;
  };

  const handleSubmit = (
    values: IAssessmentForm,
    formikHelpers: FormikHelpers<IAssessmentForm>
  ) => {
    guardReadOnlyAction("enviar valoración", "legacy-assessment-modal");
  };

  const config: FormikConfig<IAssessmentForm> = {
    initialValues: assessmentInitialForm,
    onSubmit: handleSubmit,
    validationSchema: validationAssesmentSchema
  };

  useEffect(() => {
    return () => {
      navigate(location.pathname, { replace: true });
    };
  }, []);

  return (
    <Formik {...config}>
      {formikProps => {
        return (
          <Container>
            <MxTypography
              color="grey.600"
              variant="body2"
              className="letter-content"
            >
              Apreciamos enormemente tu opinión, ya que es fundamental para nuestra
              mejora continua. ¿Qué tan cómodo/a te sentiste al utilizar nuestro
              nuevo módulo? Tu experiencia es clave para perfeccionar nuestro
              servicio, y agradecemos cualquier comentario que puedas compartir.
            </MxTypography>

            <ContainerForms>
              <RatingField name={ASSESSMENT_FORM_ENUMS.rating} size="large" />

              {/* <TextAreaField
                name={ASSESSMENT_FORM_ENUMS.comment}
                placeholder="Comentario"
              /> */}

              <MxFormL3TextAreaField
                label="Comentario"
                withreacthookform={0}
                name={ASSESSMENT_FORM_ENUMS.comment}
                placeholder="Comentario"
              />
            </ContainerForms>

            <ContainerButtons>
              <BtnSimple type="submit" isLoading={SEND_FEEDBACK_DATA.isLoading}>
                Enviar
              </BtnSimple>
            </ContainerButtons>
          </Container>
        );
      }}
    </Formik>
  );
};

const Container = styled(Form)`
  width: 100%;
  padding-top: 10px;
  .letter-content {
    text-align: justify;
    text-justify: inter-word;
  }
`;

const ContainerForms = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  margin-top: 20px;
  gap: 20px;
  span {
    align-self: center;
  }
`;

const ContainerButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;
